<template>
  <div class="overflow-y-scroll">
    <div
      class="flex flex-col bg-white min-h-full transition-all duration-100 ease-in min-w-64 w-max-content w-max max-w-64 xxl:max-w-80 relative z-10"
    >
      <ul class="ml-5 mt-32">
        <!-- BEGIN List modules -->
        <li
          v-for="page in listModulesPages"
          :key="page.id"
          :id="page.id"
          class="list-none my-2"
        >
          <div
            class="group leading-4 cursor-pointer table flex-wrap h-14 2xl:h-16 w-auto max-w-60 border border-transparent rounded-lg hover:bg-pink-600 hover:text-white focus:outline-none transition ease-in-out duration-150 text-gray-600"
            :class="{ 'bg-pink-300': infosPage.id_page === page.id }"
            @click="$emit('changePage')"
          >
            <div
              class="items-center p-4 2xl:p-5 rounded-lg text-indigo-600 group-hover:text-white group-hover:bg-pink-600 transition ease-in-out duration-150 m-1"
              :class="{ 'bg-pink-100': infosPage.id_page === page.id }"
            >
              <icon :name="page.icon" />
            </div>
            <router-link
              :to="page.name"
              class="table-cell text-base align-middle pl-1 pr-3 group-hover:text-white"
              :class="{ 'text-gray-900': infosPage.id_page === page.id }"
            >
              {{ page.display_name }}
            </router-link>
          </div>
        </li>
        <!-- END List modules -->
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from './Icon';

export default {
  components: {
    Icon,
  },
  data: function () {
    return {
      //
    };
  },
  computed: {
    ...mapGetters({
      listModulesPages: 'cartographiesIndividuelles/listModulesPages',
      infosPage: 'cartographiesIndividuelles/infosPage',
    }),
  },
};
</script>
